import { dawaAutocomplete } from 'dawa-autocomplete2'
import { onMounted } from 'vue'

export default {
    name: 'FormAddressFieldGroup',
    setup() {
        onMounted(() => {
            const mainInput = document.querySelector('.dawa-adresse-vej')
            const zipcodeInput = document.querySelector('.dawa-adresse-postnr')
            const cityInput = document.querySelector('.dawa-adresse-postnrnavn')

            // intentionally forcing input to be made in mainInput
            zipcodeInput.addEventListener('focus', () => {
                mainInput.focus()
            })
            cityInput.addEventListener('focus', () => {
                mainInput.focus()
            })

            // Se: "Google Chrome forces autofill on fields set autocomplete="off"""
            // https://github.com/alphagov/accessible-autocomplete/issues/325
            // Note: This is also defined in the razor cshtml file
            // We unfortunately need to delay setting the autocomplete attribute
            // since either chrome or froms tries to manipulate this after the
            // document is loaded.
            setTimeout(() => {
                mainInput.attributes['autocomplete'].value = 'chrome-off'
            }, 1)

            dawaAutocomplete(mainInput, {
                select: function (selected) {
                    zipcodeInput.value = selected.data.postnr
                    cityInput.value = selected.data.postnrnavn
                    //document.querySelector('#dawa-adresse-darid').innerHTML= selected.data.id;
                    setTimeout(
                        () =>
                            (mainInput.value = `${selected.data.adresseringsvejnavn} ${selected.data.husnr} ${selected.data.etage ? selected.data.etage : ''} ${selected.data.dør ? selected.data.dør : ''}`),
                        100
                    )
                }
            })
        })
    }
}
